import React from 'react';
import { useNavigate } from "react-router-dom";
import Board from 'react-trello';
//import { DataGrid } from '@mui/x-data-grid';
import {Box, Grid, Button} from '@material-ui/core';
import {Stack, Snackbar, Alert, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle} from '@mui/material';
import {OutlinedInput, Select, MenuItem, FormControl } from '@mui/material';
//import Radio from '@mui/material/Radio';
import {MetaTags} from 'react-meta-tags';
import axios from 'axios';
import Cookies from 'js-cookie';
import InputAdornment from '@mui/material/InputAdornment';
import SearchIcon from '@mui/icons-material/Search';
import LinearProgress from '@mui/material/LinearProgress'; 
//import Tooltip from '@mui/material/Tooltip';
import Authorization from '../components/Authorization';
import LeadDetails from './LeadDetails'; 
import LeadSave from './LeadSave';
import { useSelector } from 'react-redux';
import {API_URL} from '../utils/EnvVars';
import Header from "../common/HeaderMy";
import '../styles/bizofficer-a.css';
import 'font-awesome/css/font-awesome.min.css';

	var vertical='top',horizontal='center';
  
  export default function Execute() {
	const navigate = useNavigate();
	Cookies.set('leadPageUrl', 'leadskanban', { expires: new Date(new Date().getTime() + 3600000*24*5) });
	const userObj = useSelector(state => state.userDetails);	
	const isloggedin = Cookies.get('isrwadminloggedin');
	const currentChannelId = Cookies.get('currentChannelId');
	
	const childRefCaseDetails = React.useRef();
	const childRefSaveNew = React.useRef();
	const childRefSaveEdit = React.useRef();
	const childRefAuthorization = React.useRef();
	const [dataLoading, setDataLoading] = React.useState(true);
	const [privileges, setPrivileges] = React.useState("");

	const [leadType, setLeadType] = React.useState("noselect");
	const [filterType, setFilterType] = React.useState("noselect");
	const [leadChannelList, setLeadChannelList] = React.useState([]);
	const [leadTypeList, setLeadTypeList] = React.useState([]);
	const [filter, setFilter] = React.useState(false);
	const [keyword, setKeyword] = React.useState("");
	const [deleteDialogShow, setDeleteDialogShow] = React.useState(false);
	const [selectedRow, setSelectedRow] = React.useState(0);
	const [caseObj, setCaseObj] = React.useState({});

	const [dataKanban, setDataKanban] = React.useState([]);
	
	const [severityAlert, setSeverityAlert] = React.useState("error");
	const [showAlert, setShowAlert] = React.useState(false);
	const [alertMessage, setAlertMessage] = React.useState("");

	const authResult = new URLSearchParams(window.location.search); 
	const filterSearch = authResult.get('filter');
	
	// check if logged in
	React.useEffect(() => {
		if(!isloggedin){
			navigate('/login');
		}
	}, [isloggedin]);

	React.useEffect(() => {		
		if(filterSearch){
			setFilterType(filterSearch);						
		}
	}, [filterSearch]);


	React.useEffect(() => {		
		if(userObj && userObj.registerId>0){			
			if(userObj.packageId===1){
				navigate('/leads');
			}
			getApiData();
		}
	}, [userObj, filter]);

	async function getApiData(){ 
		if(currentChannelId && currentChannelId>0){
		  let queryString = '';
		  if(filterType && filterType!=='noselect'){
			queryString += '&filter='+filterType;
		  }
		  if(leadType && leadType!=='noselect'){
			queryString += '&leadType='+leadType;
		  } 
		  let apiUrl=API_URL+'/crm-list-leads-kanban?search=1&channelId='+currentChannelId+'&keyword='+keyword+queryString;
		  let axiosHeader = {
					'Content-Type': 'multipart/mixed',
					'device': 'web',
					'registerId': userObj.registerId,
					'uid': userObj.loginId,
					'fullName': userObj.fullName,
					'token': userObj.token,
			};
			const config = {
				method: 'get',
				url: apiUrl,
				headers: axiosHeader
			}
			await axios(config)
			   .then(response => {
				setDataLoading(false);
				if(response && response.status===200 && response.data && response.data.responseTxt==="success"){  
					if(response.data.list && response.data.list.length>0){
						setDataKanban(response.data.list);
					}					
					setPrivileges(response.data.privileges);
				}else if(response && response.data && response.data.responseTxt==="invalidtoken"){
					navigate('/invalidtoken');
				}else if(response && response.data && response.data.responseTxt==="NoAuthorization"){
					childRefAuthorization.current.handleClickOpen();
				}
			}).catch((error) => {
				setSeverityAlert("error");
				setShowAlert(true);
				setAlertMessage(""+error);			
				return false;
		  	})	
		}else{
			setDataLoading(false);
		}	
	}

	React.useEffect(() => {
		if(userObj && userObj.registerId>0){		
			getApiDataMultiple();			
		}
	}, [userObj]);

	async function getApiDataMultiple(){
		let axiosHeader = {
		  headers: {
			'Content-Type': 'multipart/mixed',
			'device': 'web',
			'registerId': userObj.registerId,
			'uid': userObj.loginId,
			'fullName': userObj.fullName,
			'token': userObj.token,
		  }
		};

			axios.get(API_URL+'/crmix-for-leadlist-kanban', axiosHeader)
			.then(response => {
			if(response && response.data && response.data.responseTxt==="success"){ 
				setLeadChannelList(response.data.obj.leadChannels);
				setLeadTypeList(response.data.obj.leadTypes);

			}else if(response && response.data && response.data.responseTxt==="invalidtoken"){
				navigate('/invalidtoken');
			} 		 				
			}).catch((error) => {
				setSeverityAlert("error");
				setShowAlert(true);
				setAlertMessage(""+error);			
				return false;
			})
	}

	React.useEffect(() => {
		if(leadChannelList && leadChannelList.length>0){
			if(currentChannelId && currentChannelId>0){
				handleChannelId(parseInt(currentChannelId));
			}else{
				handleChannelId(leadChannelList[0].autoId);	
			}					
		}
	}, [leadChannelList]);

	function handleChannelId(id) {		
		if(id && id>0){
			Cookies.set('currentChannelId', id, { expires: new Date(new Date().getTime() + 3600000*24*5) });
		}
		search();
	}
	
	function saveData(opt){
		if(opt===1){
			setCaseObj(null);
			setSelectedRow(0);
			childRefSaveNew.current.handleClickOpen();
		}else if(opt===2){
			childRefSaveEdit.current.handleClickOpen();
		}else if(opt===3){
			if(caseObj){
				childRefCaseDetails.current.handleClickOpen();
			}
		}
	}
	
	function deleteData(){
		if(caseObj && userObj.token){
			
			setDeleteDialogShow(false);

			let axiosHeader = {
					headers: {
					'Content-Type': 'multipart/mixed',
					'device': 'web',
					'registerId': userObj.registerId,
					'uid': userObj.loginId,
					'fullName': userObj.fullName,
			  		'token': userObj.token,
				}
			}; 

		  const data = new FormData();
		  data.append('id', caseObj.autoId);
				 
		  axios.post(API_URL+'/crm-delete-cases', data, axiosHeader)
				.then((response) => {
					///console.log("RESPONSE RECEIVED: ", response.data.responseTxt);
				if(response.data.responseTxt==="success"){
					setSeverityAlert("success");
					setShowAlert(true);
					setAlertMessage("Case has been deleted.");
					//setRows(response.data.list);					
					return false;
				}else{
			  		setSeverityAlert("error");
					setShowAlert(true);
					setAlertMessage("This case could not be deleted.");			
					return false;
				}
			}).catch((error) => {
				///console.log("AXIOS ERROR: ", error);
			})	
		}		
		
	}


	function search(){
		setFilter(!filter);
	}

	function onEnter(event){
		if(event.key === 'Enter'){
			search();
		}
	}

	function handleFilterType(val) {
		setFilterType(val);
		search();
	}

	function handleType(val) {
		setLeadType(val);
		search();
	}
		
	function deleteDialogHide(){
		setDeleteDialogShow(false);
	}

	function hideAlert(){
		setShowAlert(false);
	}

	function updatedList(list){
		setSelectedRow(0);
		setCaseObj(null);
		//setDataKanban(list);
	}

	function justclick(cardId, metadata, laneId){
		setCaseObj(metadata);
		childRefCaseDetails.current.handleClickOpen();		
		///alert(cardId+"=="+metadata+"=="+laneId);
	}
	
	return (
		<div> 
				<MetaTags>
            		<title>Leads</title>
          		</MetaTags>
				
				<Header hamburger={true} pageTitle="Leads" />
				{dataLoading?<LinearProgress />:null}

				<Box className='mainBox'>	

				    <Box mt={1} mb={1} >
							<Grid container spacing={2}>
								<Grid item md={12} xs={12} >

									<FormControl size='small' style={{width:150,marginRight:4,marginBottom:4,float:'left'}}  >
										<Select
											labelId="demo-simple-select-label"
											id="demo-simple-select"
											value={currentChannelId}
											onChange={event => handleChannelId(event.target.value)}
										>
											<MenuItem value={0}>Select Channel</MenuItem>
											{leadChannelList?leadChannelList.map((myRow,mykey)=>(
												<MenuItem key={'ct'+mykey} value={myRow.autoId}>{myRow.channelName}</MenuItem>
											)):null}
										</Select> 
									</FormControl>

									<FormControl size='small' style={{width:150,marginRight:4,marginBottom:4,float:'left'}} >
										<Select native
										 defaultValue={leadType} 
										 onChange={event => handleType(event.target.value)}
										 >
										<option value={'noselect'} >All Lead Type</option>
										{leadTypeList?leadTypeList.map((row,i)=>(
											<optgroup label={row.title} >
												{row.children?row.children.map((rw,j)=>(
													<option value={rw.id} >{rw.title}</option>
												)):null}
											</optgroup>
										)):null}
										</Select>
									</FormControl>

									<FormControl size='small' style={{width:150,marginRight:4,marginBottom:4,float:'left'}}  >
										<Select
											labelId="demo-simple-select-label"
											id="demo-simple-select"
											value={filterType}
											onChange={event => handleFilterType(event.target.value)}
										>
											<MenuItem value={'noselect'}>All Leads</MenuItem>
											<MenuItem value={'pipeline'}>Pipeline</MenuItem>
											<MenuItem value={'best-lead'}>Best-Lead</MenuItem>
											<MenuItem value={'committed'}>Committed Orders</MenuItem>
											<MenuItem value={'won'}>Won</MenuItem>
											<MenuItem value={'lost'}>Lost</MenuItem>
											<MenuItem value={'invalid'}>Invalid</MenuItem>
											<MenuItem value={'todayLeads'}>Today Leads</MenuItem>
											<MenuItem value={'thisMonthLeads'}>This Month Leads</MenuItem>
											<MenuItem value={'overdue'}>Overdue Follow-ups</MenuItem>
											<MenuItem value={'dueToday'}>Today Follow-ups</MenuItem>
											<MenuItem value={'dueTomorrow'}>Tomorrow Follow-ups</MenuItem>											
										</Select> 
									</FormControl>

									<FormControl style={{marginRight:4,marginBottom:4,float:'left'}}>
										<OutlinedInput 
										 id="keywordtxt"
										 placeholder="Search"
										 value={keyword}
										 onChange={event => setKeyword(event.target.value)}
										 onKeyPress={(event)=>{onEnter(event)}}
										 size="small"
										 endAdornment={
											  <InputAdornment position="end">
												<SearchIcon />
											  </InputAdornment>
											}
										 />
									</FormControl>

									<Button onClick={() => {search()}} style={{marginTop:1,float:'left',backgroundColor:'#FFF',textTransform: 'none'}} size="small" variant="contained"  >Search</Button>

									<div style={{float:'left'}}>

										<i onClick={()=>{window.location='leads'}} title="Leads Table" className="fa fa-table btncolor" style={{fontSize:25, marginLeft:15, cursor:'pointer'}} />

										{(privileges && privileges.indexOf("create")>-1)?	
											<i onClick={()=>{saveData(1)}} title="Add New" className="fa fa-plus-circle btncolor" style={{fontSize:25, marginLeft:15, cursor:'pointer'}} />
										:null}	
									{(selectedRow>0 && caseObj && caseObj.autoId>0)?<>
										{(privileges && ((privileges.indexOf("update")>-1 && userObj.userId===caseObj.ownerId) || privileges.indexOf("modifyall")>-1) )?	
											<i onClick={()=>{saveData(2)}} title="Edit" className="fa fa-pencil-square-o btncolor" style={{fontSize:25, marginLeft:15, cursor:'pointer'}} />
										:null}
										{(privileges && privileges.indexOf("delete")>-1)?
											<i onClick={()=>{setDeleteDialogShow(true)}} title="Delete" className="fa fa-trash btncolor" style={{fontSize:25, marginLeft:15, cursor:'pointer'}} />
										:null}
										<i onClick={()=>{saveData(3)}} title="Detail" className="fa fa-info-circle btncolor" style={{fontSize:25, marginLeft:15, cursor:'pointer'}} />
									</>:null}

										{/* <i onClick={()=>{window.location='caseskanban'}} title="View Kanban Format" className="fa fa-trello btncolor" style={{fontSize:30, marginLeft:15, cursor:'pointer'}} />
										<i onClick={()=>{window.location='caseskanban'}} title="View Calendar" className="fa fa-calendar btncolor" style={{fontSize:30, marginLeft:15, cursor:'pointer'}} />
										<i onClick={()=>{window.location='caseskanban'}} title="Advance Search" className="fa fa-search btncolor" style={{fontSize:30, marginLeft:15, cursor:'pointer'}} /> */}

									</div>	
								</Grid>
							</Grid>
					</Box>

				{(dataKanban && dataKanban.length>0)?						
						<Board 
							data={{lanes:dataKanban}} 
							onCardClick={(cardId, metadata, laneId)=>{justclick(cardId, metadata, laneId)}}
							style={{backgroundColor: '#F7F7F7'}} 
							hideCardDeleteIcon={true}
							cardDraggable={false}
						/>
				:null}	

				</Box>
				
			<LeadSave userObj={userObj} updatedList={updatedList} fullList={true} ref={childRefSaveNew} />
			<LeadDetails caseObj={caseObj} privileges={privileges} userObj={userObj} ref={childRefCaseDetails}  />						

				<Stack spacing={2} sx={{ width: '100%' }}>
					<Snackbar open={showAlert} autoHideDuration={6000} onClose={hideAlert} anchorOrigin={{vertical,horizontal}}  >
						<Alert onClose={hideAlert} variant="filled" severity={severityAlert} sx={{ width: '100%' }}>
							{alertMessage}
						</Alert>
					</Snackbar>
				</Stack>

				<Dialog
					open={deleteDialogShow}
					onClose={deleteDialogHide}
					aria-labelledby="alert-dialog-section-title"
					aria-describedby="alert-dialog-section-description"
				>
					<DialogTitle id="alert-dialog-section-title">
						Alert
					</DialogTitle>
					<DialogContent>
					<DialogContentText id="alert-dialog-section-description">
						Are you sure, You want to delete case.
					</DialogContentText>
					</DialogContent>
					<DialogActions>
					<Button variant="outlined" size="small" onClick={()=>{deleteDialogHide()}}>Don't Delete</Button>
					<Button variant="contained" size="small" color="secondary" onClick={()=>{deleteData()}} autoFocus>Yes, Delete</Button>
					</DialogActions>
				</Dialog>

			<Authorization ref={childRefAuthorization} />		
			
		</div>	
	);
  }